var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisabledIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 10 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 .5a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 1.25c.778 0 1.537.244 2.17.697L1.947 7.669A3.744 3.744 0 0 1 5 1.75m0 7.5a3.73 3.73 0 0 1-2.17-.697L8.054 3.33A3.744 3.744 0 0 1 5 9.25"
})));
export { SvgDisabledIcon as ReactComponent };
export default __webpack_public_path__ + "76d0babbb653cf445c10662a3a9592af.svg";